"use client";

import React from "react";

import Image from "next/image";
import DecorationLine from "@/components/global/ui/DecorationLine";
import WhatsappConversation from "@/components/global/sections/WhatsappConversation";
import ScrollingBanner from "@/components/global/ui/ScrollingBanner";
import {cn} from "@/lib/utils";

import {PageCommunitySchema} from "@/sanity/pages/PageCommunityTemplate";

export default function WhatsappSection({
  data,
  className
}: {
  data: PageCommunitySchema;
  className?: string;
}) {

  return (
    <section className={cn(
      "relative overflow-clip",
      className
    )}>
      <DecorationLine
        className="top-0"
        orientation="horizontal"
      />
      <DecorationLine
        className="top-[5rem] lg:top-[10rem] left-0 lg:left-[7rem] right-0 lg:right-[7rem] w-auto"
        orientation="horizontal"
      />
      <DecorationLine
        className="top-0 hidden lg:block"
        orientation="vertical"
        position="left"
      />
      <DecorationLine
        className="top-0 hidden lg:block"
        orientation="vertical"
        position="right"
      />
      <DecorationLine
        className="bottom-0"
        orientation="horizontal"
      />

      <div className="container px-0 sm:px-[2rem]">
        <div className="w-[min(124.5rem,100%)] mx-auto overflow-clip relative pt-[5rem] lg:pt-[10rem]">
          <DecorationLine
            className="top-0 left-0 hidden sm:block"
            orientation="vertical"
          />
          <DecorationLine
            className="top-0 right-0 hidden sm:block"
            orientation="vertical"
          />

          <WhatsappConversation
            messages={data?.whatsappConversation}
          />
        </div>
      </div>
    </section>
  );
}
